"use client";

import React, { useMemo } from "react";
import { UniversalEntityPage } from "@/components/shared/UniversalEntityPage";
import { useTimeEntryHooks } from "@/lib/hooks/api/time-entries/time-entry-hooks";
import AutoImportModal from "@/components/shared/modals/AutoImportModal";
import { getEntityTableConfig } from "@/lib/entity-registry";
import type { Time_Entries } from "@/src/gql/graphql";

const TIME_ENTRY_CONFIG = getEntityTableConfig<Time_Entries>("time_entries");

interface TicketTimeEntriesTableProps {
  ticketId: string;
  ticketNumber?: string;
}

export function TicketTimeEntriesTable({ ticketId, ticketNumber }: TicketTimeEntriesTableProps) {
  // Create hooks for time entries
  const timeEntryHooks = useTimeEntryHooks();

  // Memoize custom components to prevent recreation
  const customComponents = useMemo(
    () => ({
      importModal: (props: any) => (
        <AutoImportModal config={TIME_ENTRY_CONFIG} hooks={timeEntryHooks} {...props} />
      ),
    }),
    [timeEntryHooks]
  );

  // Custom filter to show only time entries for this ticket
  const customFilters = useMemo(
    () => ({
      ticket_id: ticketId,
    }),
    [ticketId]
  );

  return (
    <div className="w-full">
      <UniversalEntityPage
        entityName="time_entries"
        config={TIME_ENTRY_CONFIG}
        hooks={timeEntryHooks}
        filterPreset="all"
        title={`Time Entries for Ticket ${ticketNumber || ticketId}`}
        description={"View and manage time entries for this ticket"}
        storageKey={`ticket-${ticketId}-time-entries-column-preferences`}
        customComponents={customComponents}
        customFilters={customFilters}
        showHeader={false} // Hide the header since it's embedded in a tab
      />
    </div>
  );
}
